import React, { useRef, useState } from "react";
import { AuthenticationApi } from "../../services/akfenservicesprod/api";

function Login() {
  //#region API
  const authenticationProdApi = new AuthenticationApi({
    username: "akfeninsaat-avocet",
    password: "G*W8Cc/k?zK&Pp9",
  });

  let api = authenticationProdApi;

  //#endregion

  const [errorHeader, setErrorHeader] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const passwordRef = useRef(null);

  const handleSubmit = async (e) => {
    
    if (api !== undefined && api !== "") {     

      api.authenticationGet(passwordRef.current.value).then((response) => {
        
        if (response.status === 200) {
          debugger;
          let datas = response.data;
          
          if(datas === "invalid-password")
          {
            setErrorHeader("Hatalı Şifre");
            setErrorMessage("Lütfen tekrar giriş yapınız...");
          }
          else
            localStorage.setItem("loginKey",datas);
          window.location.href = "/fileupload"
        }
      });
    }
  };

  return (
    <div className="file-upload-login">
      <div id="logindiv">
        <div className="wrapper fadeInDown">
          <div id="formContent">
            <input
              ref={passwordRef}
              className="fadeIn third"
              type="password"
              id="password"
              placeholder="Şifre"
            />
            <input
              type="button"
              className="fadeIn fourth"
              onClick={(e) => {
                e.preventDefault();
                handleSubmit(e);
              }}
              value="Bağlan"
            />
          </div>
        </div>
      </div>
      {errorHeader !== "" && (
        <div className="alert alert-danger" role="alert">
          <h4 className="alert-heading">{errorHeader}</h4>
          <p>{ errorMessage }</p>
        </div>
      )}
    </div>
  );
}

export default Login;
